
import {
	CHANGE_NEW_PREMIUM_STORE_SETTINGS,
	CHANGE_PREMIUM_SETTINGS_FORM_INFO_STATE,
	CHANGE_PS_TYPE, CHANGE_SOLICITOR_GROUP, CHANGE_WORKSOURCE,
	DISPLAY_ONLY_LIVE_PREMIUM_SETTINGS,
	FAILED_GET_ALL_PREMIUM_SETTINGS, FAILED_GET_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP,
	FAILED_TO_GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
	FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES, FAILED_TO_GET_PREMIUM_SETTINGS_STAGES,
	FAILED_TO_GET_PREMIUM_SETTINGS_WITH_COMBINATION, GET_ALL_PREMIUM_SETTINGS, GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
		GET_PREMIUM_SETTINGS_FOR_SOLICITOR_GROUP_AND_WORKSOURCE, GET_PREMIUM_SETTINGS_WITH_COMBINATION,
	NEW_PREMIUM_SETTINGS_PROPERTIES, OPEN_MODAL, PREMIUM_SETTINGS_GO_TO_PAGE, PREMIUM_SETTINGS_PAGE_SHIFT,
	RECEIVE_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
		RECEIVE_BAD_REQUEST_DELETE_PREMIUM_SETTING,
	RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING,
	RECEIVE_BAD_REQUEST_POST_NEW_POLICY_SETTING, RECEIVE_BAD_REQUEST_PREMIUM_SETTING_BY_ID,
	RECEIVE_DELETE_PREMIUM_SETTING,
	RECEIVE_GET_GROUP_WORK_SOURCES, RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING, RECEIVE_POST_RESPONSE_NEW_PREMIUM_SETTING,
	RECEIVE_PREMIUM_SETTINGS_BY_ID, RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN,
	RECEIVE_PREMIUM_SETTINGS_DAMAGES, RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN, RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN,
	RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES, RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES_CHAIN,
	RECEIVE_PREMIUM_SETTINGS_SCHEDULES, RECEIVE_PREMIUM_SETTINGS_STAGES, RECEIVE_PREMIUM_SETTINGS_STAGES_CHAIN,
	RECEIVE_PREMIUM_SETTINGS_SUB_CASES_CHAIN, RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION,
	RECEIVE_SUB_CASE_TYPES_PREMIUM_SETTINGS,
	RECEIVED_ALL_PREMIUM_SETTINGS, RECEIVED_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP, REQUEST_DELETE_PREMIUM_SETTING,
	REQUEST_GET_SPECIFIC_PREMIUM_SETTING,
	REQUEST_PATCH_PREMIUM_SETTING,
	REQUEST_POST_NEW_PREMIUM_SETTING,
	REQUEST_PREMIUM_SETTINGS_DAMAGES,
	REQUEST_PREMIUM_SETTINGS_SCHEDULE_TYPES,
	REQUEST_PREMIUM_SETTINGS_SCHEDULES, REQUEST_PREMIUM_SETTINGS_STAGES,
	CHANGE_PREMIUM_SETTINGS_WITH_COMBINATION,
	UPDATE_DISPLAYED_PREMIUM_SETTINGS
} from "./index";


export function receiveSubCaseTypesPremiumSettings(response){
	return{
		type: RECEIVE_SUB_CASE_TYPES_PREMIUM_SETTINGS,
		payload: response
	}
}

export function changePremiumSettingsFormInfoState(key){
	return{
		type: CHANGE_PREMIUM_SETTINGS_FORM_INFO_STATE,
		payload: {
			key
		}
	}
}

export function getAllPremiumSettings(){
	return{
		type: GET_ALL_PREMIUM_SETTINGS
	}
}

export function receivedAllPremiumSettings(payload){
	return{
		type: RECEIVED_ALL_PREMIUM_SETTINGS,
		payload
	}
}

export function receivedBadRequestAllPremiumSettings(payload){
	return{
		type: FAILED_GET_ALL_PREMIUM_SETTINGS,
		payload
	}
}

export function updateDisplayed(payload){
	return{
		type: UPDATE_DISPLAYED_PREMIUM_SETTINGS,
		payload
	}
}

export function displayOnlyLive(){
	return {
		type: DISPLAY_ONLY_LIVE_PREMIUM_SETTINGS
	}
}

export function changeNewPremiumSettingsProperties(payload){
	return {
		type: NEW_PREMIUM_SETTINGS_PROPERTIES,
		payload
	}
}

export function receivedGroupWorkSources(payload){
	return {
		type: RECEIVE_GET_GROUP_WORK_SOURCES,
		payload
	}
}

export function changepsType(payload){
	return {
		type: CHANGE_PS_TYPE,
		payload
	}
}

export function openModal(payload){
	return {
		type: OPEN_MODAL,
		payload
	}
}

export function changeSolicitorGroup(payload){
	return {
		type: CHANGE_SOLICITOR_GROUP,
		payload
	}
}

export function changeWorksource(payload){
	return {
		type: CHANGE_WORKSOURCE,
		payload
	}
}


export function changeNewPremiumStoreSettings(key,value){
	return {
		type: CHANGE_NEW_PREMIUM_STORE_SETTINGS,
		payload : {
			key,
			value
		}

	}
}

//function that requests post new premium setting
export function requestPostNewPremiumSetting(sendBody) {
	return {
		type: REQUEST_POST_NEW_PREMIUM_SETTING,
		payload: sendBody
	}
}

//function that receives post response to create new premium setting
export function receivePostResponseNewPremiumSetting(response) {
	return {
		type: RECEIVE_POST_RESPONSE_NEW_PREMIUM_SETTING,
		payload: response
	}
}

//function that receives bad request from posting new premium setting
export function receiveBadRequestPostNewPremiumSetting(response) {
	return {
		type: RECEIVE_BAD_REQUEST_POST_NEW_POLICY_SETTING,
		payload: response
	}
}

//function that requests damages
export function requestPremiumSettingsDamages() {
	return {
		type: REQUEST_PREMIUM_SETTINGS_DAMAGES
	}
}


//function that receives damages
export function receivePremiumSettingsDamages(damages) {
	return {
		type: RECEIVE_PREMIUM_SETTINGS_DAMAGES,
		payload: damages
	}
}

//action that receives failed response getting premium settings damages
export function failedToGetPremiumSettingsDamages(response) {
	return {
		type: FAILED_TO_GET_PREMIUM_SETTINGS_DAMAGES,
		payload: response
	}
}

//function that requests stages
export function requestPremiumSettingsStages() {
	return {
		type: REQUEST_PREMIUM_SETTINGS_STAGES
	}
}


//function that receives stages
export function receivePremiumSettingsStages(stages) {
	return {
		type: RECEIVE_PREMIUM_SETTINGS_STAGES,
		payload: stages
	}
}

//action that receives failed response getting the premium settings case stages
export function failedToGetPremiumSettingsStages(response) {
	return {
		type: FAILED_TO_GET_PREMIUM_SETTINGS_STAGES,
		payload: response
	}
}

//function that requests Schedules
export function requestPremiumSettingsSchedules() {
	return {
		type: REQUEST_PREMIUM_SETTINGS_SCHEDULES
	}
}


//function that receives Schedules
export function receivePremiumSettingsSchedules(schedules) {
	return {
		type: RECEIVE_PREMIUM_SETTINGS_SCHEDULES,
		payload: schedules
	}
}

//function that requests Schedules Types
export function requestPremiumSettingsScheduleTypes(id) {
	return {
		type: REQUEST_PREMIUM_SETTINGS_SCHEDULE_TYPES
	}
}


//function that receives Schedules Types
export function receivePremiumSettingsScheduleTypes(scheduleTypes) {
	return {
		type: RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES,
		payload: scheduleTypes
	}
}



//function that requests post new premium setting
export function requestPatchPremiumSetting(sendBody) {
	return {
		type: REQUEST_PATCH_PREMIUM_SETTING,
		payload: sendBody
	}
}

//function that receives post response to create new premium setting
export function receivePatchResponsePremiumSetting(response) {
	return {
		type: RECEIVE_PATCH_RESPONSE_PREMIUM_SETTING,
		payload: response
	}
}

//function that receives bad request from posting new premium setting
export function receiveBadRequestPachPremiumSetting(response) {
	return {
		type: RECEIVE_BAD_REQUEST_PATCH_POLICY_SETTING,
		payload: response
	}
}



export function getPRemiumSettingsForSolicitorGroupAndWorkSource(solGroupId, workSourceId){
	return{
		type: GET_PREMIUM_SETTINGS_FOR_SOLICITOR_GROUP_AND_WORKSOURCE,
		payload:{
			solGroupId,
			workSourceId,
		}
	}
}

export function receivedAllPremiumSettingsForSolGroup(payload){
	return{
		type: RECEIVED_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP,
		payload
	}
}

export function receivedBadRequestAllPremiumSettingsForSolGroup(payload){
	return{
		type: FAILED_GET_ALL_PREMIUM_SETTINGS_FOR_SOL_GROUP,
		payload
	}
}

export function deletePremiumSetting(payload){
	return{
		type: REQUEST_DELETE_PREMIUM_SETTING,
		payload
	}
}

export function receiveDeletePremiumSetting(payload){
	return{
		type: RECEIVE_DELETE_PREMIUM_SETTING,
		payload
	}
}

export function receiveBadRequestDeletePremiumSetting(payload){
	return{
		type: RECEIVE_BAD_REQUEST_DELETE_PREMIUM_SETTING,
		payload
	}
}


//action that shifts the page value +-1
export function pageShift(direction, totalPaginationBoxes){
	return {
		type: PREMIUM_SETTINGS_PAGE_SHIFT,
		payload: {
			direction: direction,
			totalPaginationBoxes: totalPaginationBoxes
		}
	}
}

//action that shifts the page value +-1
export function goToPage(payload){
	return {
		type: PREMIUM_SETTINGS_GO_TO_PAGE,
		payload
	}
}


//=====================================//
//action that requests get specific premium setting EDIT
export function requestGetSpecificPremiumSetting(payload) {
    return {
        type: REQUEST_GET_SPECIFIC_PREMIUM_SETTING,
        payload: payload
    }
}

export function receivePremiumSettingDamagesChain(payload) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_DAMAGES_CHAIN,
        payload: payload
    }
}

export function receivePremiumSettingsCaseTypesChain(payload) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_CASE_TYPES_CHAIN,
        payload: payload
    }
}

export function receivePremiumSettingsStagesChain(payload) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_STAGES_CHAIN,
        payload: payload
    }
}

export function receivePremiumSettingsSolicitorChain(payload) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_SOLICITOR_CHAIN,
        payload: payload
    }
}

export function receivePremiumSettingById( payload ) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_BY_ID,
        payload: payload
    }
}

export function receiveBadRequestPremiumSettingById( response ) {
    return {
        type: RECEIVE_BAD_REQUEST_PREMIUM_SETTING_BY_ID,
        payload: response
    }
}

export function receivePremiumSettingsScheduleTypesChain( scheduleTypes) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_SCHEDULE_TYPES_CHAIN,
        payload: scheduleTypes
    }
}

export function receivePremiumSettingsSubCasesChain( subCases) {
    return {
        type: RECEIVE_PREMIUM_SETTINGS_SUB_CASES_CHAIN,
        payload: subCases
    }
}


//===============================//

//action that requests get premium settings with the combination of case type, solicitor
// group, sub case type and work source.
export function getPremiumSettingWithCombination(caseTypeId, subCaseTypeId, solicitorGroupId, workSourceId, isTypePercentage) {
	return {
		type: GET_PREMIUM_SETTINGS_WITH_COMBINATION,
		payload:{
			caseTypeId,
			subCaseTypeId,
			solicitorGroupId,
			workSourceId,
			isTypePercentage
		}
	}
}

//action that receives bad request from getting the premium settings with combination
export function receivePremiumSettingsWithCombination(response) {
	return {
		type: RECEIVE_PREMIUM_SETTINGS_WITH_COMBINATION,
		payload: response
	}
}

export function changePremiumSettingWithCombination(response) {
	return {
		type: CHANGE_PREMIUM_SETTINGS_WITH_COMBINATION,
		payload: response
	}
}

//action that receives failed response from getting premium setting with combination
export function failedToGetPremiumSettingsWithCombaination(response) {
	return {
		type: FAILED_TO_GET_PREMIUM_SETTINGS_WITH_COMBINATION,
		payload: response
	}
}


//action that requests get all premium settings with the combination of case type, solicitor
// group, sub case type and work source.
export function getAllPremiumSettingsWithCombination(payload) {
	return {
		type: GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
		payload
	}
}

//action that gets all the premium settings with combination
export function receiveAllPremiumSettingsWithCombination(payload) {
	return {
		type: RECEIVE_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
		payload
	}
}

//action that receives failed response from getting all premium settings with combination
export function failedToGetAllPremiumSettingsWithCombaination(payload) {
	return {
		type: FAILED_TO_GET_ALL_PREMIUM_SETTINGS_WITH_COMBINATION,
		payload
	}
}